import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const SolicitudCamioneta = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/solicitud-camioneta.pdf`;
  /*const pdfUrl = "/pdf/solicitud-camioneta.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Solicitud Camioneta</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Solicitud Camioneta" />
      </Container>
    </>
  );
};

 export default SolicitudCamioneta;
